export const toDTO = (team) => ({
    id: team.id,
    name: team.name,
    active: team.active,
    description: team.description,
    members: team.members.map((person) => person.personId),
});
